<template>
  <div>
    <h4>Payroll Settings </h4>
    <v-container>
      <v-row>
        <v-col cols="6" sm="12" md="12" lg="6">
          <v-row>
            <v-col cols="4"   
              v-for='(role, index) in droles'
              :key='index'
            >
              <v-switch
                v-model="settings"
                color="success"
                :label="role"
                :value="role"
                hide-details
                inset
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn
            depressed
            color="primary"
            @click="saveSettings()"
          >
            Save
          </v-btn>
        </v-col>
      </v-row>
    </v-container>  
  </div>
</template>
<script>
  import axios from 'axios';
  const url = require("../../../client_config/config").url;
  import { mapMutations, mapState  } from "vuex";

  export default {
    data: () => ({
      settings: [],
    }),

    computed:{
      ...mapState({
          droles: 'userRoles',
      })
    },

    created(){
      //console.log(droles);
      this.getSettings();
    },

    methods: {
      ...mapMutations({
        setSnackbar: "SET_SNACKBAR",
      }),

      saveSettings(){
        const req_body = {
          Roles: this.settings
        }
        axios.put(`${url}/payroll/settings`, req_body).then(res => {
          if(res.status === 200){
            this.setSnackbar({
              show: true,
              text: "Save Successfully",
              color: "green accent-4",
            });
          }else{
            this.setSnackbar({
              show: true,
              text: "Error Upon Saving...",
              color: "red accent-4",
            });
          }
        });
      },

      async getSettings(){
         await axios.get(`${url}/payroll/settings`).then(res => {
          console.log(res);
          this.settings = res.data.Roles;
          //console.log(this.settings)
        });
      }

    },

  }
</script>
